module.exports = __webpack_public_path__ + "public/img/space.15ce5405.png";